/**
 * Resolve the API base URL.
 *
 * Prefers a runtime override on `window.API_URL` so Cypress (and any other
 * tooling that needs to redirect the app to a different API) can stomp on it
 * before the React bundle executes via `Cypress.on("window:before:load", ...)`.
 * Falls back to the build-time env var for normal dev/prod usage.
 */
export function getApiBase() {
  if (typeof window !== "undefined" && window.API_URL) return window.API_URL;
  return process.env.REACT_APP_API;
}

export default getApiBase;
